"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareMulticall = prepareMulticall;
const viem = __importStar(require("viem"));
const Multicall_1 = __importDefault(require("./abis/Multicall"));
const MULTICALL_ADDRESS = '0xE2C5658cC5C448B48141168f3e475dF8f65A1e3e';
function prepareMulticall(txns) {
    // Calculate the total value of all transactions
    const value = txns.reduce((val, txn) => {
        return val + (BigInt(txn.value || 0) || BigInt(0));
    }, BigInt(0));
    return {
        abi: Multicall_1.default,
        address: MULTICALL_ADDRESS,
        functionName: 'aggregate3Value',
        value,
        args: [
            txns.map((txn) => ({
                target: txn.address || viem.zeroAddress,
                callData: viem.encodeFunctionData(txn),
                value: txn.value || '0',
                requireSuccess: true,
            })),
        ],
    };
}
//# sourceMappingURL=multicall.js.map